<div class="d-flex flex-column align-items-start align-self-stretch gap-4 p-3 w-100"
  style="background: var(--neutral-white, #FFF);">

  <div class="d-flex justify-content-between align-items-center align-self-stretch pb-3 border-bottom border-2">
    <div class="fs-5 fw-bold"> Instant Rates Manager</div>
  </div>

  <div class="d-flex align-items-start bg-info-subtle border border-info-subtle rounded p-4 gap-3 w-100">
    <i class="bi bi-info-circle-fill text-info fs-3"></i>
    <div class="flex-grow-1">
      <p class="mb-2">
        For your rate cards (instant prices) to be served to customers, a minimum level of detail is required.
        You can upload a bulk list of routes and rates, or enter them manually line by line.
      </p>
      <p class="mb-0">
        For guidance on how to use Truckit's Instant Rates Manager, see our
        <a href="https://help.truckit.net/support/solutions/articles/35000175754-what-is-the-truckit-reference-number-on-my-bank-statement-"
          target="_blank" class="fw-semibold text-decoration-none">
          information and examples here
        </a>.
      </p>
    </div>
  </div>

  <div class="container-fluid py-4">
    <div class="row g-4">

      <div class="col-12 col-md-6 col-lg-4">
        <div class="card bg-secondary-subtle border-0 h-100 p-4 rounded-4">
          <div class="card-body text-center d-flex flex-column align-items-center justify-content-between">
            <div class="w-100">
              <h5 class="fw-bold">View or edit your current rates</h5>

              <!-- Centered button -->
              <div class="d-flex justify-content-center mb-1">
                <button type="button" (click)="goTo('/instant-rate-manager/rates')"
                  class="btn btn-outline-secondary my-4 d-flex align-items-center btn-white-bg gap-2">
                  <i class="bi bi-lightning-fill fs-4"></i>
                  <span>Go to instant rates</span>
                </button>
              </div>

              <p class="text-muted mb-0 text-start">
                You can edit your instant rates, switch them on or off, and update as needed.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="card border-4 border-secondary shadow-sm h-100 p-4 rounded-4">
          <div class="card-body text-center d-flex flex-column align-items-center justify-content-between">
            <div class="w-100">
              <h5 class="fw-bold">Bulk upload new instant rates</h5>

              <!-- Centered button -->
              <div class="d-flex justify-content-center">
                <button type="button" (click)="openBulkUploadRateModal()"
                  class="btn btn-secondary text-white my-4 d-flex align-items-center gap-2">
                  <i class="bi bi-upload fs-4"></i>
                  <span>Upload CSV</span>
                </button>
              </div>

              <p class="text-muted mb-0 text-start">
                Download an example CSV using Truckit’s
                <a href="#" class="text-info text-decoration-none">preferred instant rates format.</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <div class="card border-4 border-secondary shadow-sm h-100 p-4 rounded-4">
          <div class="card-body text-center d-flex flex-column align-items-center justify-content-between">
            <div class="w-100">
              <h5 class="fw-bold">Manage instant rate locations</h5>

              <div class="d-flex justify-content-center">
                <button (click)="goTo('/instant-rate-manager/provider-locations')"
                  class="btn btn-secondary text-white my-4 d-flex align-items-center gap-2">
                  <i class="bi bi-geo-alt fs-4"></i>
                  <span>Location settings</span>
                </button>
              </div>

              <p class="text-muted mb-0 text-start">
                You can set up your delivery zones or edit your existing locations and depots.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 5 -->
      <div class="col-12 col-md-6 col-lg-4">
        <div class="card border-4 border-secondary shadow-sm h-100 p-4 rounded-4">
          <div class="card-body text-center d-flex flex-column align-items-center justify-content-between">
            <div class="w-100">
              <h5 class="fw-bold">Applicable terms and conditions</h5>

              <div class="d-flex justify-content-center">
                <button class="btn btn-secondary text-white my-4 d-flex align-items-center gap-2"
                  (click)="openTermsSelectionModal(termsSelectionModal)">
                  <i class="bi bi-info-circle fs-4"></i>
                  <span>Update terms</span>
                </button>
              </div>

              <p class="text-muted mb-0 text-start">
                All instant rates need to have terms and conditions to protect you and your customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #termsSelectionModal let-modal>
  <div class="modal-header border-0 pt-4 px-4">
    <h5 class="modal-title fw-bold text-dark">Update Terms & Conditions</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-4 pt-2">
    <p class="text-muted small mb-4">Choose general terms that apply to all categories, or manage terms for a specific freight category.</p>

    <div *ngIf="isLoadingTermsCategories" class="text-center py-4">
      <div class="spinner-border text-primary opacity-50" role="status"></div>
    </div>

    <div *ngIf="!isLoadingTermsCategories" class="d-flex flex-column gap-3">
      <div class="card border shadow-sm cursor-pointer" (click)="goToGeneralTerms()">
        <div class="card-body p-3 d-flex align-items-center gap-3">
          <div class="rounded-circle p-2 bg-primary-subtle text-primary">
            <i class="bi bi-globe fs-5"></i>
          </div>
          <div class="flex-grow-1">
            <div class="fw-bold">General Terms & Conditions</div>
            <div class="text-muted small">Provider-wide terms that apply across all categories</div>
          </div>
          <i class="bi bi-chevron-right text-muted"></i>
        </div>
      </div>

      <div *ngFor="let cat of termsCategories" class="card border shadow-sm cursor-pointer" (click)="goToCategoryTerms(cat.value)">
        <div class="card-body p-3 d-flex align-items-center gap-3">
          <div class="rounded-circle p-2 bg-light text-secondary">
            <i class="bi bi-file-text fs-5"></i>
          </div>
          <div class="flex-grow-1">
            <div class="fw-bold">{{ cat.label }}</div>
            <div class="text-muted small">{{ cat.description }}</div>
          </div>
          <i class="bi bi-chevron-right text-muted"></i>
        </div>
      </div>
    </div>
  </div>
</ng-template>
